import { getVoidProdcutoTerminadoDTO, ProductoTerminadoDTO } from "../interfaces/ProductoTerminadoDTO";
import { ResponceApi } from "../interfaces/Responses";
import { IDatosRespuesta } from "../interfaces/RespuestaDTO";
import { Scopus } from "../interfaces/Scopus";
import { ProductoEsperado, objProductoEsperado } from "../interfaces/Sistema";
import { TablaProductoIngresadoDTO } from "../interfaces/TablaProductoIngresadoDTO";
import axios, { AxiosResponse } from "axios";
import { TblDecInvImportadoScopus } from "../interfaces/TblDecInvImportacionScopus";
import { ImportadoScopusDTO } from "../interfaces/ImportadoScopusDTO";
import { AdjuntarProductoDTO } from "../interfaces/ProductosDTOS/AdjuntarProyectoDTO";
import { ProductoColaboradorDTO } from "../interfaces/ColaboradorProdcutoDTO";
import { TblProductoProdTermin } from "../interfaces/TblProductoProdTermin";
import { Option } from '../interfaces/ProyectosDTOS/Option';
import { GetVoidReviewEid, ReviewEid } from "../interfaces/ProductosDTOS/ReviewEid";
const localBack: string = process.env.REACT_APP_BACK || '';
const APICATALOGO: string = '/api/Producto';
const burn: string = "https://192.168.3.17:443";
const ToProduccion: string = 'https://wssaac.espol.edu.ec/investigacion';
const ToTest: string = 'http://192.168.253.6:8955';

export default class ProductoService {

  async GetProductoTerminadoById(id: number, token: any): Promise<ResponceApi<ProductoTerminadoDTO>> {
    const response1: AxiosResponse<ResponceApi<ProductoTerminadoDTO>> = await axios.get(localBack + APICATALOGO + '/GetProductoTerminadoById/' + id,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    //console.log(response1.data);        
    return response1.data;
  }

  async GetAdjuntarProductoById(id: number, token: any): Promise<ResponceApi<AdjuntarProductoDTO>> {
    const response1: AxiosResponse<ResponceApi<AdjuntarProductoDTO>> = await axios.get(localBack + APICATALOGO + '/GetAdjuntarProductoById/' + id,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    //console.log(response1.data);        
    return response1.data;
  }

  async SoftDeleteProductoById(id: number, token: any): Promise<ResponceApi<ProductoTerminadoDTO>> {
    const response1: AxiosResponse<ResponceApi<ProductoTerminadoDTO>> = await axios.get(localBack + APICATALOGO + '/SoftDeleteProductoById/' + id,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    //console.log(response1.data);        
    return response1.data;
  }

  async GetProductoTerminadoWithProyecto(idproyecto: number, nombreInv: string, token: any): Promise<ResponceApi<ProductoTerminadoDTO>> {
    const response1: AxiosResponse<ResponceApi<ProductoTerminadoDTO>> = await axios.get(localBack + APICATALOGO + '/GetProductoByProyecto/' + idproyecto + '&' + nombreInv,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    //console.log(response1.data);        
    return response1.data;
  }

  async GetConferenciaById(id: number, token: any): Promise<ResponceApi<ProductoTerminadoDTO>> {
    try {
      const response1: AxiosResponse<ResponceApi<ProductoTerminadoDTO>> = await axios.get(localBack + APICATALOGO + '/GetConferencia/' + id,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      if (response1.data) {
        return response1.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GetProductosIngresadosUsuario(id: number, token: any): Promise<ResponceApi<TablaProductoIngresadoDTO>> {
    try {
      const response: AxiosResponse<ResponceApi<TablaProductoIngresadoDTO>> = await axios.get(
        localBack + APICATALOGO + '/GetProductosIngresadosUsuario/' + id,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data);
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GetProductosIngresadosUsuarioSinProyecto(id: number, token: any): Promise<ResponceApi<TablaProductoIngresadoDTO>> {
    try {
      const response: AxiosResponse<ResponceApi<TablaProductoIngresadoDTO>> = await axios.get(
        localBack + APICATALOGO + '/GetProductosIngresadosUsuarioSinProyecto/' + id,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data);
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }
  async GetProductosProyectosParticipo(id: number, token: any): Promise<ResponceApi<TablaProductoIngresadoDTO>> {
    try {
      const response: AxiosResponse<ResponceApi<TablaProductoIngresadoDTO>> = await axios.get(
        localBack + APICATALOGO + '/GetProductosTerminadosProyectosParticipo/' + id,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data);
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GuardarProductoTerminado(producto: ProductoTerminadoDTO, token: any): Promise<ProductoTerminadoDTO> {
    try {
      // var formData = new FormData();
      const response: AxiosResponse<ProductoTerminadoDTO> = await axios.post(
        localBack + APICATALOGO + '/GuardarProductoTerminado',
        producto,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data)
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GuardarProductoTerminadoIDatos(producto: ProductoTerminadoDTO, token: any): Promise<IDatosRespuesta<ProductoTerminadoDTO>> {
    try {
      const response: AxiosResponse<IDatosRespuesta<ProductoTerminadoDTO>> = await axios.post(
        localBack + APICATALOGO + '/GuardarProductoTerminado',
        producto,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data)
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GuardarProductoTerminadoContext(producto: ProductoTerminadoDTO, token: any): Promise<ResponceApi<ProductoTerminadoDTO>> {
    try {
      console.log(producto)
      const response: AxiosResponse<ResponceApi<ProductoTerminadoDTO>> = await axios.post(
        localBack + APICATALOGO + '/GuardarProductoTerminadoContext',
        producto,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data)
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      return {
        status: { isSuccessfully: false, messages: ['Error al enviar al guardar el producto'] },
        operation: 0,
        statusCode: 500,
        count: 0,
        listData: [],
        data: getVoidProdcutoTerminadoDTO(),
      }
    }
  }

  async UpdateTblProductoTerminadoContext(producto: TblProductoProdTermin, token: any): Promise<ResponceApi<TblProductoProdTermin>> {
    try {
      const response: AxiosResponse<ResponceApi<TblProductoProdTermin>> = await axios.post(
        localBack + APICATALOGO + '/UpdateTblProductoTerminadoContext',
        producto,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data)
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GuardarAdjuntarProyectoContext(adjunto: AdjuntarProductoDTO, token: any): Promise<ResponceApi<AdjuntarProductoDTO>> {
    try {
      const response: AxiosResponse<ResponceApi<AdjuntarProductoDTO>> = await axios.post(
        localBack + APICATALOGO + '/GuardarAdjuntarProyectoContext',
        adjunto,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data)
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GuardarColaboradorProductoTerminadoContext(colaborador: ProductoColaboradorDTO, token: any): Promise<ResponceApi<ProductoColaboradorDTO>> {
    try {
      const response: AxiosResponse<ResponceApi<ProductoColaboradorDTO>> = await axios.post(
        localBack + APICATALOGO + '/GuardarColaboradorProductoTerminadoContext',
        colaborador,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data)
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async DeleteColaboradorProducto(idproyecto: number, idcolaborador: number, token: any): Promise<ResponceApi<string>> {
    try {
      // var formData = new FormData();
      const response: AxiosResponse<ResponceApi<string>> = await axios.delete(
        localBack + APICATALOGO + '/EliminarColaborador/' + idproyecto + '&' + idcolaborador,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        let resp = response.data;
        //console.log(resp.strEstado);
        return resp;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async DeleteSolicitanteProducto(idsolicitante: number, token: any): Promise<ResponceApi<string>> {
    try {
      // var formData = new FormData();
      const response: AxiosResponse<ResponceApi<string>> = await axios.delete(
        localBack + APICATALOGO + '/EliminarSolicitante/' + idsolicitante,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        let resp = response.data;
        //console.log(resp.strEstado);
        return resp;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async DeleteObjetivoProducto(idobjetivo: number, token: any): Promise<ResponceApi<string>> {
    try {
      // var formData = new FormData();
      const response: AxiosResponse<ResponceApi<string>> = await axios.delete(
        localBack + APICATALOGO + '/EliminarObjEspecifico/' + idobjetivo,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        let resp = response.data;
        //console.log(resp.strEstado);
        return resp;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async DeleteRelacionProyecto(idobjetivo: number, token: any): Promise<ResponceApi<string>> {
    try {
      // var formData = new FormData();
      const response: AxiosResponse<ResponceApi<string>> = await axios.delete(
        localBack + APICATALOGO + '/EliminarRelacionProyecto/' + idobjetivo,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        let resp = response.data;
        //console.log(resp.strEstado);
        return resp;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async DeleteResultadoProducto(idobjetivo: number, token: any): Promise<ResponceApi<string>> {
    try {
      // var formData = new FormData();
      const response: AxiosResponse<ResponceApi<string>> = await axios.delete(
        localBack + APICATALOGO + '/EliminarResultado/' + idobjetivo,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        let resp = response.data;
        //console.log(resp.strEstado);
        return resp;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async DeleteFactorImpactoProducto(idFactor: number, token: any): Promise<ResponceApi<string>> {
    try {
      // var formData = new FormData();
      const response: AxiosResponse<ResponceApi<string>> = await axios.delete(
        localBack + APICATALOGO + '/EliminarFactorImpacto/' + idFactor,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        let resp = response.data;
        //console.log(resp.strEstado);
        return resp;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GetListScopus(id: string, token: any): Promise<ResponceApi<Array<Scopus>>> {
    try {
      const response: AxiosResponse<ResponceApi<Array<Scopus>>> = await axios.get(
        localBack + APICATALOGO + '/ListScopus/' + id,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GetListScopusSpecific(id: any, token: any): Promise<ResponceApi<Scopus>> {
    try {
      const response: AxiosResponse<ResponceApi<Scopus>> = await axios.get(
        localBack + APICATALOGO + '/ListScopus/' + id,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data)
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async ImportarScopus(scopus: Scopus, token: any): Promise<ResponceApi<ProductoTerminadoDTO>> {
    try {
      const response: AxiosResponse<ResponceApi<ProductoTerminadoDTO>> = await axios.post(
        localBack + APICATALOGO + '/ConvertScopusToProducto',
        scopus,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data)
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GuardarImportacionScopus(registro: TblDecInvImportadoScopus, token: any): Promise<ResponceApi<TblDecInvImportadoScopus>> {
    try {
      // var formData = new FormData();
      const response: AxiosResponse<ResponceApi<TblDecInvImportadoScopus>> = await axios.post(
        localBack + APICATALOGO + '/GuardarImportacionScopus',
        registro,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data)
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GetListImportadosScopus(token: any): Promise<ResponceApi<ImportadoScopusDTO>> {
    try {
      const response: AxiosResponse<ResponceApi<ImportadoScopusDTO>> = await axios.get(
        localBack + APICATALOGO + '/GetImportadosScopus/',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data)
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GuardarProductoEsperado(producto: objProductoEsperado, token: any): Promise<ResponceApi<objProductoEsperado>> {
    try {
      const response: AxiosResponse<ResponceApi<objProductoEsperado>> = await axios.post(
        localBack + APICATALOGO + '/GuardarProductoEsperado',
        producto,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GetProductoEsperadoById(idProducto: number, token: any): Promise<ResponceApi<ProductoEsperado>> {
    const response1: AxiosResponse<ResponceApi<ProductoEsperado>> = await axios.get(localBack + APICATALOGO + '/GetProdEsperadoById/' + idProducto,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    return response1.data;
  }

  async ActualizarProductoEsperado(token: any, prodEsperado: objProductoEsperado): Promise<ResponceApi<objProductoEsperado>> {
    try {
      const response: AxiosResponse<ResponceApi<objProductoEsperado>> = await axios.put(
        localBack + APICATALOGO + '/ActualizarProductoEsperado',
        prodEsperado,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GetRutaArchivo(idProducto: number, numarch: number, token: any): Promise<ResponceApi<any>> {
    const response1: AxiosResponse<ResponceApi<any>> = await axios.get(localBack + APICATALOGO + '/GetRutaArchivo/' + idProducto + '&' + numarch,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    return response1.data;
  }

  async GetOptionsProdTerminByTitulo(titulo: string, token: any): Promise<ResponceApi<Option>> {
    const response1: AxiosResponse<ResponceApi<Option>> =
      await axios.get(localBack + APICATALOGO + '/GetOptionsProdTerminByTitulo/' + titulo,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
    //console.log(response1.data);        
    return response1.data;
  }

  async GetProductosTerminadosPorTitulo(titulo: string, token: any): Promise<ResponceApi<TablaProductoIngresadoDTO>> {
    try {
      const response: AxiosResponse<ResponceApi<TablaProductoIngresadoDTO>> = await axios.get(
        localBack + APICATALOGO + '/GetProductosTerminadosPorTitulo/' + titulo,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data);
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }
  async GetProductosTerminadosPorTituloWithIdProducto(idproducto: string | number, token: any): Promise<ResponceApi<TablaProductoIngresadoDTO>> {
    try {
      const response: AxiosResponse<ResponceApi<TablaProductoIngresadoDTO>> = await axios.get(
        localBack + APICATALOGO + '/GetProductosTerminadosPorTituloWithIdProducto/' + idproducto,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data);
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      throw error; // Re-lanzar el error para que se maneje donde se llama a la función
    }
  }

  async GetPublicationScopusByEid(token: any, eid: string): Promise<ResponceApi<ProductoTerminadoDTO>> {
    try {
      const response: AxiosResponse<ResponceApi<ProductoTerminadoDTO>> = await axios.post(
        //ToProduccion + APICATALOGO + '/GetPublicationScopusByEid',
        //ToTest + APICATALOGO + '/GetPublicationScopusByEid',
        localBack + APICATALOGO + '/GetPublicationScopusByEid',
        {
          "eid": eid
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data)
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      return {
        status: { isSuccessfully: false, messages: ['Error al enviar al guardar el producto'] },
        operation: 0,
        statusCode: 500,
        count: 0,
        listData: [],
        data: getVoidProdcutoTerminadoDTO(),
      }
    }
  }
  
  async GetPublicationScopusByDoi(token: any, doi: string): Promise<ResponceApi<ProductoTerminadoDTO>> {
    try {
      const response: AxiosResponse<ResponceApi<ProductoTerminadoDTO>> = await axios.post(
        //ToProduccion + APICATALOGO + '/GetPublicationScopusByDoi',
        //ToTest + APICATALOGO + '/GetPublicationScopusByDoi',
        localBack + APICATALOGO + '/GetPublicationScopusByDoi',
        {
          "eid": doi
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data)
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      return {
        status: { isSuccessfully: false, messages: ['Error al enviar al guardar el producto'] },
        operation: 0,
        statusCode: 500,
        count: 0,
        listData: [],
        data: getVoidProdcutoTerminadoDTO(),
      }
    }
  }

  async ReviewEid(token: any, producto: ProductoTerminadoDTO): Promise<ResponceApi<ReviewEid>> {
    try {
      const response: AxiosResponse<ResponceApi<ReviewEid>> = await axios.post(
        localBack + APICATALOGO + '/ReviewEid',
        producto,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data) {
        //console.log(response.data)
        return response.data;
      } else {
        throw new Error('No se recibieron datos válidos.');
      }
    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      return {
        status: { isSuccessfully: false, messages: ['Error al enviar al guardar el producto'] },
        operation: 0,
        statusCode: 500,
        count: 0,
        listData: [],
        data: GetVoidReviewEid(),
      }
    }
  }
}